import collectionSymbols from "../symbols/collections";

const initialState = {
  data: [],
  loading: false,
  error: false,
};

export default function CollectionSymbolsReducer(
  state = initialState,
  action: any
) {
  switch (action.type) {
    case collectionSymbols.GET_COLLECTIONS:
      return { ...state, loading: true, error: false };
    case collectionSymbols.GET_COLLECTIONS_SUCCESS:
      return {
        ...state,
        data: action.payload.Result,
        loading: false,
        error: false,
      };
    case collectionSymbols.GET_COLLECTIONS_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
    case collectionSymbols.CLEAR_GET_COLLECTIONS:
      return {
        ...state,
        data: [],
        loading: false,
        error: false,
      };

    default:
      return state;
  }
}
